module.exports = __webpack_public_path__ + "static/media/Languages-asset1.7377719e.svg";